@if (imgSrc() === null) {
  <div class="empty-placeholder">
    <a class="far fa-image empty-placeholder-icon"></a>
    {{ "imgGallery.imgGalleryItem.couldNotLoadImage" | translate }}
  </div>
} @else {
  <a
    class="galleryimgs"
    [href]="imgSrc()!"
    data-type="image"
    [attr.data-gallery]="galleryId()"
    ><div class="tile">
      <img [src]="imgSrc()!" class="img-el" />
    </div>
  </a>
}
